<template>
  <v-dialog
    v-model="open"
    width="600px"
    :fullscreen="isMobileBreakpoint"
    :persistent="isMobileBreakpoint"
  >
    <v-card>
      <v-toolbar elevation="0" color="background">
        <v-toolbar-title class="pl-3">
          <span class="newFolderTitle"
            >{{ isCreate ? $t('message.create') : $t('message.rename') }}
            playlist
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="handleClose()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="pl-7 pr-5 py-0">
        <v-container class="pl-0">
          <v-row no-gutters>
            <v-col cols="12" class="mb-2">
              <span class="newFolderName">{{ $t('message.title') }}</span>
            </v-col>
            <v-col cols="12">
              <v-form ref="form" v-model="valid" v-on:submit.prevent>
                <v-input
                  v-model="playlistName"
                  autofocus
                  outlined
                  dense
                  :rules="[rules.required, rules.maxLength, rules.minLength]"
                  required
                  counter="40"
                  maxLength="40"
                  color="primary"
                  @keyup.enter="handleEnter"
                ></v-input>
              </v-form>
            </v-col>
            <v-col v-if="isCreate" cols="12" class="mt-6">
              <span class="newFolderName">{{ $t('message.description') }}</span>
            </v-col>
            <v-col v-if="isCreate" cols="12">
              <v-form ref="form" v-model="valid" v-on:submit.prevent>
                <v-input
                  v-model="playlistDescription"
                  outlined
                  dense
                  :rules="[
                    rules.maxLengthDescription,
                    rules.minLengthDescription,
                  ]"
                  counter="160"
                  maxLength="160"
                  color="primary"
                  @keyup.enter="handleEnter"
                ></v-input>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-col cols="12" class="mt-1 mb-3 px-0 mx-0">
        <v-divider />
      </v-col>
      <v-card-actions
        :class="isMobileBreakpoint ? 'mobile-actions' : ''"
        class="px-8 pb-6"
      >
        <v-spacer></v-spacer>
        <base-btn
          type="tertiary"
          class="mr-4 px-4 rounded-lg elevation-0"
          :disabled="isFetching"
          color="#EDEEF1"
          @click="handleClose"
        >
          {{ $t('message.cancel') }}
        </base-btn>
        <base-btn
          type="primary"
          large
          @click="handleConfirm"
          :loading="isFetching"
          :disabled="!valid || isFetching"
        >
          {{ isCreate ? $t('message.create') : $t('message.rename') }}
        </base-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import i18n from '@/translations/lang'
import playlistApi from '@/services/playlistApi'

export default {
  name: 'EditPlaylistModal',
  components: {},
  data: () => ({
    open: false,
    isFetching: false,
    playlist: {},
    playlistName: '',
    playlistDescription: '',
    valid: false,
    rules: {
      required: (v) => (v && !!v) || i18n.t('message.requiredField'),
      maxLength: (v) =>
        (v && v.length <= 40) || i18n.t('message.maximumLength'),
      minLength: (v) => (v && v.length > 2) || i18n.t('message.minimumLength'),
      maxLengthDescription: (v) =>
        (v && v.length <= 160) || i18n.t('message.maximumLength'),
      minLengthDescription: (v) =>
        (v && v.length > 2) || i18n.t('message.minimumLength'),
    },
    isCreate: false,
  }),
  watch: {
    open() {
      const refForm = this.$refs.form
      refForm && refForm.resetValidation()
    },
  },
  computed: {
    ...mapState('user', {
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
  },
  mounted() {
    this.$root.$on('editPlaylistModal', (playlist, isCreate) => {
      Object.assign(this.$data, this.initialState())
      this.playlist = playlist
      if (!isCreate) this.playlistName = playlist.name
      this.isCreate = isCreate
      this.open = true
    })
    this.$root.$on('changeLanguage', () => {
      this.rules = {
        required: i18n.t('message.requiredField'),
        maxLength: i18n.t('message.maximumLength'),
        minLength: i18n.t('message.minimumLength'),
        maxLengthDescription: i18n.t('message.maximumLength'),
        minLengthDescription: i18n.t('message.minimumLength'),
      }
    })
  },

  beforeDestroy() {
    this.$root.$off('editPlaylistModal')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    ...mapActions('user', ['addUser', 'editUser', 'addFolder', 'editFolder']),
    handleConfirm() {
      if (this.isCreate) {
        this.handleCreate()
      } else {
        this.handleEdit()
      }
    },
    async handleCreate() {
      this.isFetching = true
      let playlistObject = {
        name: this.playlistName.trim(),
        description: this.playlistDescription.trim(),
        access_type: 'anyone_with_link',
        creator_name: this.$store.state.user?.userInfo?.name || 'Usuário',
      }
      try {
        let ret = await playlistApi.createPlaylist(playlistObject)
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          type: 'success',
          text: 'Playlist criada com sucesso',
          buttons: [
            {
              text: i18n.t('message.actions.open'),
              size: 'small',
              style: 'font-size: 12px',
              type: 'neutral',
              onClick: () => {
                this.$router.push({
                  name: 'Playlists',
                  params: { id: ret.data.id },
                })
              },
            },
          ],
        })
        this.$root.$emit('addPlaylistVideosPage', ret.data)
        this.$router.push({ name: 'PlaylistPage', params: { id: ret.data.id } })
      } catch (e) {
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: `${e}`,
        })
      }
      this.isFetching = false
      this.handleClose()
    },
    async handleEdit() {
      this.isFetching = true
      try {
        await playlistApi.updatePlaylist(
          { name: this.playlistName.trim() },
          this.playlist.id
        )
        this.playlist.name = this.playlistName
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: `Playlist ${this.playlist.name} renomeada`,
          type: 'success',
        })
        this.$root.$emit('updatePlaylistPage', this.playlist)
      } catch (e) {
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: `${e}`,
        })
      }
      this.isFetching = false
      this.handleClose()
    },
    handleClose() {
      this.open = null
    },
    handleEnter() {
      if (this.valid) {
        this.edit ? this.handleEdit() : this.handleCreate()
      }
    },
    initialState() {
      return {
        open: false,
        isFetching: false,
        playlist: {},
        playlistName: '',
        playlistDescription: '',
        valid: false,
        rules: {
          required: (v) => (v && !!v) || i18n.t('message.requiredField'),
          maxLength: (v) =>
            (v && v.length <= 40) || i18n.t('message.maximumLength'),
          minLength: (v) =>
            (v && v.length > 2) || i18n.t('message.minimumLength'),
          maxLengthDescription: (v) =>
            (v && v.length <= 160) || i18n.t('message.maximumLength'),
          minLengthDescription: (v) =>
            (v && v.length > 2) || i18n.t('message.minimumLength'),
        },
        isCreate: false,
      }
    },
  },
}
</script>

<style>
.newFolderTitle {
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
}
.newFolderName {
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
}
.mobile-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--v-background-base);
  z-index: 10;
  padding: 16px;
}
</style>
